window.degToRad = function degToRad(degrees)
{
    return degrees * Math.PI / 180;
};

window.radToDeg = function radToDeg(radians)
{
    return radians * 180 / Math.PI;
};


window.UTIL = {
    sortArrayByKey()
    {
        const sorters = {
            string(a, b)
            {
                if (a < b)
                {
                    return -1;
                }
                else if (a > b)
                {
                    return 1;
                }

                return 0;
            },

            number(a, b)
            {
                return a - b;
            },
        };

        return function sortIt(ary, prop)
        {
            const type = typeof ary[0][prop] || 'string';

            return ary.sort((a, b) =>
                sorters[type](a[prop], b[prop]));
        };
    },

    isNotNumeric(n)
    {
        return !(!isNaN(parseFloat(n)) && isFinite(n));
    },

    uniq(array)
    {
        const result = Array.from(new Set(array));

        return result;
    },

    lastItem(array)
    {
        const length = array === null ? 0 : array.length;

        return length ? array[length - 1] : undefined;
    },

    keys(obj)
    {
        if (typeof obj !== 'object')
        {
            return [];
        }

        const keys = [];

        for (const k in obj)

        {
            keys.push(k);
        }

        return keys;
    },

    contains(a, obj)
    {
        if (!a || !obj)
        {
            return false;
        }

        let i = 0;

        while (i < a.length)
        {
            if (a[i] === obj)

            {
                return true;
            }

            i += 1;
        }

        return false;
    },

    clone(obj)
    {
        return JSON.parse(JSON.stringify(obj));
    },

    getQueryParam(variable, query)
    {
        if (!query)

        {
            query = window.location.search.substring(1);
        }

        let variables = [];

        if (typeof variable === 'string')

        {
            variables = [variable.toLowerCase()];
        }

        else

        {
            for (const v of Array.from(variable))

            {
                variables.push(v.toLowerCase());
            }
        }

        const vars = query.split('&');
        let i = 0;

        while (i < vars.length)
        {
            const pair = vars[i].split('=');

            if (Array.from(variables).includes(pair[0].toLowerCase()))

            {
                return this.parseValues(pair[1]);
            }

            i += 1;
        }

        return null;
    },

    getQueryAsObj(query)
    {
        if (!query)

        {
            query = window.location.search.substring(1);
        }

        const tmp = {};
        const vars = query.split('&');
        let i = 0;

        while (i < vars.length)
        {
            const pair = vars[i].split('=');

            tmp[pair[0]] = pair[1];
            i += 1;
        }

        return tmp;
    },

    parseValues(v)
    {
        if (typeof v !== 'string')
        {
            return v;
        }
        if (v === '')
        {
            return null;
        }
        if (v === 'true')
        {
            return true;
        }
        if (v === 'false')
        {
            return false;
        }
        if (!isNaN(Number(v)))
        {
            return Number(v);
        }
        if (v === 'null')
        {
            return null;
        }

        return v;
    },

    hexToString(int)
    {
        const k = (int + Math.pow(16, 6)).toString(16).substr(-6);

        return `#${k.toString(16)}`;
    },
};




// WEBPACK FOOTER //
// ./babel/app/util.js